import { useEffect, useRef } from 'react';
import { Dialog, CircularProgress, Box } from '@mui/material';
//
// ################################################################################
//
const WaitingDialog = ({ open }) => {
  const focusRef = useRef(null);

  useEffect(() => {
    if (!open) {
      return;
    };
    const t = setTimeout(() => focusRef.current?.focus({ preventScroll: true }), 0);
    return () => clearTimeout(t);
  }, [open]);

  return (
    <Dialog
      open={open}
      PaperProps={{
        sx: {
          backgroundColor: "transparent",
          boxShadow: "none",
          overflow: "visible",
        },
      }}
    >
      <Box
        ref={focusRef}
        component="div"
        tabIndex={0}
        autoFocus
        role="progressbar"
        aria-label="Cargando"
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "200px",
          outline: "none",
        }}
      >
        <CircularProgress
          thickness={4}
          size={50}
          sx={{ color: '#0D47A1' }}
        />
      </Box>
    </Dialog>
  );
};
export default WaitingDialog;
